<script setup lang="ts">
import { watch, ref } from "vue";
import Routes, { RoutePage } from "../base/Routes.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    labels: string[];
    pages: RoutePage[];
    initIndex?: number;
  }>(),
  {
    initIndex: 0
  }
);

const emits = defineEmits<{
  (event: "changedIndex", index: number): void;
}>();

const selectedIndex = ref(props.initIndex);

const headerRef = ref<HTMLElement>();

const headerTabRefs = ref<Array<any>>([]);
const setHeaderTabRefs = (el: any, index: number) => {
  if (el) {
    headerTabRefs.value.push({
      index,
      el
    });
  }
};

watch([headerRef, headerTabRefs], () => {
  computeIndicatorLocation();
});

const indicatorX = ref<number>(0);
const indicatorY = ref<number>(0);
const indicatorWidth = ref<number>(0);
function computeIndicatorLocation() {
  if (headerRef.value && headerTabRefs.value.length) {
    const parentRect = headerRef.value.getBoundingClientRect();
    const destRect =
      headerTabRefs.value[selectedIndex.value].el.getBoundingClientRect();
    indicatorX.value = destRect.x - parentRect.x;
    indicatorY.value = destRect.y - parentRect.y + destRect.height - 2;
    indicatorWidth.value = destRect.width;
  }
}

const routesRef = ref();
let isSettled = false;
watch(routesRef, () => {
  if (!routesRef.value || isSettled) {
    return;
  }
  isSettled = true;
  routesRef.value.reset(props.pages, () => {
    changeTab(props.initIndex);
  });
});

function changeTab(index: number) {
  selectedIndex.value = index;
  emits("changedIndex", index);
  computeIndicatorLocation();
  routesRef.value?.goto(index);
}

defineExpose({});
</script>

<template>
  <div class="tabs">
    <div
      class="header"
      ref="headerRef"
    >
      <div
        v-for="(label, index) in props.labels"
        :key="label"
        :class="index == selectedIndex ? 'active' : ''"
        @click="changeTab(index)"
      >
        <div :ref="(el) => setHeaderTabRefs(el, index)">
          {{ label }}
        </div>
      </div>
      <div
        class="indicator"
        :style="{
          top: indicatorY + 'px',
          left: indicatorX + 'px',
          width: indicatorWidth + 'px',
          height: '2px'
        }"
      ></div>
    </div>
    <div class="content">
      <Routes ref="routesRef" />
    </div>
  </div>
</template>

<style scoped>
.tabs {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.content {
  flex: 1 1 auto;
}
.header {
  flex: 0 0 auto;
  position: relative;
  display: flex;
  font-size: 14px;
  line-height: 1;
  color: #999999;
  box-sizing: border-box;
}
.header .active {
  color: #5a82f0;
}
.header > div {
  flex: 1 1 auto;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  background-color: #ffffff;
  position: relative;
  box-sizing: border-box;
}
.header > div > div {
  box-sizing: border-box;
  padding: 10px 0;
}
.header > div.indicator {
  display: inline-block;
  flex: 0;
  position: absolute;
  background-color: #5a82f0;
  transition: all ease-out 200ms;
}
</style>
